const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速缓冲 不卡顿',
    desc: '采用多节点CDN智能加速技术，无论热门大片还是冷门剧集，加载速度始终流畅。告别转圈等待，点击秒开高清画质。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全终端适配',
    desc: '完美兼容手机、平板、电脑等所有设备，无需安装任何插件或APP，浏览器打开即可享受高清影视体验。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '全网资源聚合',
    desc: '实时收录久久视频、芒果视频、97视频、丝瓜视频等平台最新资源，一个站点看遍全网热门电影电视剧全集。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净观影体验',
    desc: '无弹窗广告、无强制跳转、无恶意插件，全程清爽界面。专注内容本身，让每一帧画面都不被打扰。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-24 bg-white">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-950 mb-3">
            为什么选择苹果视频
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            用心打造极致观影平台，让免费看片变得更简单
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:bg-background-100"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 font-serif">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}